<template>
  <div>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
          <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
          <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-card class="box">
          <center>
              <strong> Current Academic Year {{ academicYear }}</strong>
          </center>
          <v-toolbar v-if="student_receipts.length > 0" flat dense class="toolbar" align="center" justify="center">
              <v-toolbar-title>Previous Outstanding Fees Receipts</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
          </v-toolbar>
          <br />
          <v-data-table :headers="headers1" :items="student_receipts" :search="search" class="elevation-1 mytable" dense v-if="student_receipts.length > 0">
              <template v-slot:item.print="{ item }">
                  <v-tooltip top color="warning">
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs" v-on="on" @click="print(item.receipt_no, item.ay)"> <v-icon color="warning">mdi-printer</v-icon>Print Receipt</v-btn>
                      </template>
                      <span> Print Fee Receipt!!! </span>
                  </v-tooltip>
              </template>
              <template v-slot:item.delete="{ item }">
                  <v-tooltip top color="red">
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn class="mt-1 mb-1" rounded outlined small color="red" v-bind="attrs" v-on="on" @click="deletedialog(item.receipt_no, item.ay)"> <v-icon color="red">mdi-delete-circle</v-icon>Delete</v-btn>
                      </template>
                      <span> Delete!!! </span>
                  </v-tooltip>
              </template>
          </v-data-table>
          <span
              v-if="
        student_outstanding_fees_list.length > 0 ||
        student_outstanding_fees_list == '' ||
        student_outstanding_fees_list == ''
      "
          >
          </span>
          <v-toolbar v-if="student_outstanding_fees_list.length > 0" flat dense class="toolbar" align="center" justify="center">
              <v-toolbar-title>Student Oustanding Fees Details</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
          </v-toolbar>
          <br />
          <v-data-table :headers="headers" :items="student_outstanding_fees_list" :search="search" class="elevation-1 mytable" dense v-if="student_outstanding_fees_list.length > 0">
              <template v-slot:item.select_payment_mode="{ item }">
                  <div v-if="item.balance > 0">
                      <!-- <v-autocomplete v class="mb-none pb-none mt-4" color="#0F2027" dense rounded required v-model="item.select_mode" :items="payment_modes" item-text="payment_mode_name" item-value="paymentmode_id" label="Payment Mode" outlined /> -->
                      <lable>Select Payment Mode</lable>
                      <select class="select" v-model="item.select_mode" name="payment_mode_name" id="paymentmode_id" data-live-search="true" data-show-subtext="true">
                          <option value="0">--Please select payment mode</option>
                          <option v-for="p in payment_modes" :value="p">
                              {{ p.payment_mode_name }}
                          </option>
                      </select>
                  </div>
                  <div v-else class="text">
                      <strong>Already Paid</strong>
                  </div>
              </template>
                  <template v-slot:[`item.fine`]="{ item }">
                  <div v-if="item.fine > 0"> 
                      <input placeholder="Fine Amount." class="input text-center" type="number" v-model="item.fine" :name="item.pay_fee" />
                  </div> 
                   <div v-else class="text">
                      <strong>Already Paid</strong>
                  </div>
              </template>

              <template v-slot:[`item.pay_fee`]="{ item }">
                  <div v-if="item.balance > 0">
                      <!-- <v-text-field class="mt-none pt-none" rounded label="Enter Amount" hide-details="auto" v-model="item.pay_fee" outlined dense></v-text-field> -->
                      <input placeholder="Enter Amount." class="input text-center" type="number" v-model="item.pay_fee" :name="item.pay_fee" :rules="[(v) => !!v || 'Required' || v >= 0]" />
                      <!-- <input placeholder="Enter Amount." class="input text-center" type="number" v-model="item.pay_fee" :name="item.pay_fee" @change="applyfine(item)" :rules="[(v) => !!v || 'Required' || v >= 0]" /> -->
                  </div>
                  <div v-else class="text">
                      <strong>Already Paid</strong>
                  </div>
              </template>
              <template v-slot:[`item.pay_date`]="{ item }">
                  <div v-if="item.balance > 0">
                      <input id="datePickerId" type="date" v-model="item.pay_date" />
                  </div>
                  <div v-else class="text">
                      <strong>Already Paid</strong>
                  </div>
              </template>
              <template v-slot:[`item.trxn_date`]="{ item }">
                  <div v-if="item.balance > 0">
                      <input id="datePickerId" type="date" v-model="item.trxn_date" />
                  </div>
                  <div v-else class="text">
                      <strong>Already Paid</strong>
                  </div>
              </template>
              <template v-slot:[`item.remark`]="{ item }">
                  <div v-if="item.balance > 0">
                      <input placeholder="Enter Remark." class="input text-center" type="text" v-model="item.remark" :name="item.remark" :rules="[(v) => !!v || 'Required' || v >= 0]" />

                      <!-- <v-text-field class="mt-none pt-none" rounded label="Enter Remark" hide-details="auto" v-model="item.remark" outlined dense></v-text-field> -->
                  </div>
                  <div v-else class="text">
                      <strong>Already Paid</strong>
                  </div>
              </template>
              <template v-slot:[`item.pay_button`]="{ item }">
                  <div v-if="item.balance > 0">
                      <v-btn outlined rounded class="button" small @click="payfees(item)">Pay Now</v-btn>
                  </div>
                  <div v-else class="text">
                      <strong>Already Paid</strong>
                  </div>
              </template>
          </v-data-table>
      </v-card>
      <v-dialog v-model="dialog_delete_option1" persistent max-width="500px">
          <v-card>
              <v-container>
                  <v-card class="box">
                      <input type="hidden" v-model="deleteItem_opt1.delete_id1" />
                      <v-row dense justify="center">
                          <v-col cols="12" sm="6" md="6">
                              <p><b>Remark</b></p>
                              <v-textarea outlined name="input-7-4" v-model="addRemark" label="Enter Remark"> </v-textarea>
                          </v-col>
                      </v-row>
                      <center>
                          <strong>Are you sure you want Delete this fee???</strong>
                      </center>
                      <v-row justify="center">
                          <v-btn class="button" text @click="dialog_delete_option1 = false">No</v-btn>
                          <v-btn class="button" text c :disabled="addRemark != '' ? false : true" @click="deletestudent(addRemark)">Yes</v-btn>
                      </v-row>
                  </v-card>
              </v-container>
          </v-card>
      </v-dialog>
      <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
  </div>
</template>
<script>
  import "@/assets/css/color.css"; // css needs to be imported for each dashboard
  import axios from "axios";
  export default {
      props: {
          registration_no: String,
          ay:String
      },
      data: () => ({
          show: false,
          stud_list: [],
          snackbar_msg: "",
          color: "",
          snackbar: false,
          overlay: false,
          current_ay: "",
          remark: null,
          search: "",
          s3url: "",
          academicYear: null,
          addRemark: "",
          headers: [
              { text: "Sr. No.", value: "srno" },
              { text: "PRN No.", value: "stud_reg_no", align: "center" },
              { text: "Academic Year", value: "of_academicyear" },
              { text: "Fees", value: "fee" },
              { text: "Paid Fees", value: "paid_fee" },
              { text: "Balance", value: "balance" },
               { text: "Weekly Fine (If Applicable)", value: "fine", align: "center" },
              { text: "Amount", value: "pay_fee", width: 300 },
              { text: "Payment Mode", value: "select_payment_mode", width: 300 },
              { text: "Date", value: "pay_date", width: 300 },
              { text: "Transaction Date", value: "trxn_date", width: 300 },
              { text: "Remark", value: "remark", width: 300 },
              { text: "Pay", value: "pay_button", align: "center" },
          ],
          headers1: [
              { text: "Sr. No.", value: "srno" },
              { text: "PRN No.", value: "registration_number" },
              { text: "Name", value: "name" },
              { text: "For Academic Year", value: "of_ay" },
              { text: "Standard", value: "standard" },
              { text: "Quota", value: "quota" },
              { text: "Stream", value: "stream" },
              { text: "Receipt No", value: "receipt_no" },
              { text: "Receipt Date", value: "receipt_date" },
              { text: "Transaction Date", value: "trxn_date" },
              { text: "Amount", value: "amount" },
              { text: "Fine", value: "fine" },
              { text: "Payment Mode", value: "payment_mode" },
              { text: "Remark", value: "remark" },
              { text: "Print Receipt", value: "print", sortable: true },
              { text: "Delete Receipt", value: "delete", sortable: true },
          ],
          student_outstanding_fees_list: [],
          payment_modes: [],
          select_mode: "",
          new_input: "",
          student_receipts: [],
          dialog_delete_option1: false,
          deleteItem_opt1: {
              delete_id1: "",
              delete_id2: "",
          },
      }),
      watch: {
          registration_no() {
              this.getDetails();
          },
          ay(){
            this.getDetails();
          }
      },
      methods: {
        applyfine(item){
            if(parseFloat(item.balance) != 0){
                item.pay_fee =  parseFloat(item.pay_fee) + parseFloat(item.fine)
            }
        },
          deletedialog(item, ay) {
              this.dialog_delete_option1 = true;
              this.deleteItem_opt1.delete_id1 = item;
              this.deleteItem_opt1.delete_id2 = ay;
          },
          deletestudent(remark) {
              const formdata = {
                  receipt_no: this.deleteItem_opt1.delete_id1,
                  ay: this.deleteItem_opt1.delete_id2,
                  reason_for_delete: remark,
              };
              axios
                  .post("/OutstandingFees/deleteOutstanding", formdata)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.dialog_delete_option1 = false;
                          this.showSnackbar("#4caf50", "Student Fee deleted successfully");
                          this.getDetails();
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong !!!");
                          this.dialog_delete_option1 = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong !!!");
                      this.dialog_delete_option1 = false;
                  })
                  .finally(() => {
                      this.dialog_delete_option1 = false;
                  });
          },
          print(receipt_no, ay) {
              this.receipt_no = receipt_no;
              this.$session.set("receipt_no", JSON.stringify(receipt_no));
              this.$session.set("ay", JSON.stringify(ay));
              this.$session.set("registration_no", JSON.stringify(this.registration_no.registration_number));
              // this.$router.push({
              //     name: "student-outstanding-payment-receipt",
              // });
              let routeData = this.$router.resolve({
                  name: "student-outstanding-payment-receipt",
              });
              window.open(routeData.href, "_blank");
          },
          payfees(item) {
            // if(parseFloat(item.balance) != 0){
            //     item.balance =  parseFloat(item.balance) + parseFloat(item.fine)
            //     alert(item.balance)
            // }
              if (item.pay_fee == null || item.pay_fee == "") {
                  this.showSnackbar("#b71c1c", "Please enter fees amount!");
                  return;
              } else if (item.select_mode == null || item.select_mode == "") {
                  this.showSnackbar("#b71c1c", "Please select Payment Mode!");
                  return;
              } else if (item.pay_date == null || item.pay_date == "") {
                  this.showSnackbar("#b71c1c", "Please select Payment Date!");
                  return;
              } else if (item.pay_fee > item.balance) {
                  this.showSnackbar("#b71c1c", "Fee should be less than balnce!!");
                  return;
              } else {
                  const data = {
                      fees_amount: item.pay_fee,
                      fine_amount: item.fine,
                      payment_mode: item.select_mode.paymentmode_id,
                      outstanding_fee_id: item.outstanding_fee_id,
                      learner_reg_no: this.registration_no.registration_number,
                      ay:this.ay,
                      remark: item.remark,
                      pay_date: item.pay_date,
                      trxn_date: item.trxn_date,
                  };
                  this.overlay = true;
                  axios
                      .post("OutstandingFees/save_offline_outstanding_fees", data)
                      .then((res) => {
                          this.overlay = false;
                          if (res.data.flag == "YES") {
                              //move to fees receipt
                              this.showSnackbar("#4CAF50", "Payment Done Successfully..");
                              this.getDetails();
                              this.select_mode = "";
                          }
                          if (res.data.flag == "NO") {
                              this.showSnackbar("#b71c1c", res.data.snackbar);
                              return;
                          }
                      })
                      .catch((error) => {
                          this.overlay = false;
                          window.console.log(error);
                          this.showSnackbar("#b71c1c", "Something Went Wrong");
                      })
                      .finally(() => {
                          this.overlay = false;
                      });
              }
          },
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
          getDetails() {
              const formData = {
                  registration_no: this.registration_no.registration_number,
                  ay:this.ay
              };
              this.overlay = true;
              axios
                  .post("OutstandingFees/getLearnerData", formData)
                  .then((res) => {
                      this.overlay = false;
                      if (res.data.flag == "YES") {
                          this.student_outstanding_fees_list = res.data.array_of_sof;
                          this.payment_modes = res.data.payment_modes;
                          this.student_receipts = res.data.student_receipts;
                          this.academicYear = res.data.academicYear;
                      }
                      if (res.data.flag == "NO") {
                          this.showSnackbar("#b71c1c", res.data.snackbar);
                          return;
                      }
                  })
                  .catch((error) => {
                      this.overlay = false;
                      window.console.log(error);
                      this.showSnackbar("#b71c1c", "Something Went Wrong");
                  })
                  .finally(() => {
                      this.overlay = false;
                  });
          },
      },

      mounted() {
          this.getDetails();
      },
  };
</script>
<style scoped>
  input[type="number"] {
      width: 100%;
      display: inline-block;
      border: 1px solid black;
      border-radius: 4px;
      box-sizing: border-box;
  }
  input[type="text"] {
      width: 100%;
      display: inline-block;
      border: 1px solid black;
      border-radius: 4px;
      box-sizing: border-box;
  }
  .select {
      width: 100%;
      display: inline-block;
      border: 1px solid black;
      border-radius: 4px;
      box-sizing: border-box;
  }
  .text {
      color: red !important;
  }
  .radiospace {
      margin: 1rem !important;
      padding: 0%;
  }
  .btn-css {
      outline: 0 !important;
      outline-offset: 0 !important;
      background-image: none !important;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
      background-color: #fff !important;
      text-decoration: underline;
      color: #0f2027 !important;
      text-align: left;
  }

  .btn-css:hover {
      outline: 0 !important;
      outline-offset: 0 !important;
      background-image: none !important;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
      background-color: #ffff !important;
      color: #0f2027 !important;
      text-decoration: underline;
      text-align: left;
  }
  .t-row {
      padding: 1rem i !important;
  }
  .mytable2 /deep/ thead th {
      background: #0f2027 !important; /* fallback for old browsers */
      background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
      background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
      background-color: #0f2027 !important;
      color: white !important;
      font-weight: bold !important;
      white-space: nowrap !important;
      text-align: center;
  }
  .delete-avatar {
      transition: 0.3s;
      border: 1px solid red;
      margin: 0.2rem !important;
  }
  .delete-avatar:hover {
      background-color: transparent;
  }
  .delete-v-icon {
      padding-left: 8px;
      padding-top: 1px;
      font-size: 15px;
  }
  .delete-v-icon:hover {
      color: white;
  }
  .v-dialogss {
      bottom: 880;
      right: 0;
  }
  input[type="date"] {
      width: 100%;
      display: inline-block;
      padding: 0.3rem;
      border: 1px solid gray;
      border-radius: 30px;
      box-sizing: border-box;
      padding-top: none !important;
      margin-top: none !important;
  }
</style>
